/**
 * フォントライセンス表記ページ (/licenses、spec/06 E3)。
 * 本サイトは DVI をクライアントでラスタライズするため、
 * フォントプログラム自体を配信している。その出所と許諾を明示する。
 */
export function Licenses() {
  return (
    <>
      <div className="hero">
        <h1>フォントライセンス</h1>
        <p>
          本サイトは TeX の組版結果 (DVI)
          をブラウザ内でラスタライズして表示しており、そのためにフォントプログラムを配信しています。使用フォントの出所とライセンスは次の通りです。
        </p>
      </div>
      <section className="card">
        <h2>欧文・数式フォント</h2>
        <ul>
          <li>
            Computer Modern (cmr, cmmi, cmsy, cmex ほか) — Donald E. Knuth 作。Type1 化は BlueSky
            Research / Y&amp;Y による寄贈を経て American Mathematical Society
            が配布するもので、自由に再配布できます。
          </li>
          <li>
            AMS フォント (msam, msbm, eufm ほか) — American Mathematical Society 作 (SIL Open Font
            License 1.1)。
          </li>
          <li>Ralph Smith&apos;s Formal Script (rsfs) — Ralph Smith 作、自由に再配布できます。</li>
          <li>
            Latin Modern (lmroman) — GUST e-foundry 作 (
            <a href="/fonts/GUST-FONT-LICENSE.TXT" target="_blank" rel="noreferrer">
              GUST Font License
            </a>
            )。
          </li>
        </ul>
      </section>
      <section className="card">
        <h2>和文フォント</h2>
        <ul>
          <li>
            原ノ味フォント (原ノ味明朝・原ノ味角ゴシック) — Masamichi Hosoda 氏による Adobe
            源ノ明朝/源ノ角ゴシック派生フォント (SIL Open Font License 1.1、
            <a href="/fonts/LICENSE-HaranoAji.txt" target="_blank" rel="noreferrer">
              ライセンス全文
            </a>
            )。本サイトでは使用文字のサブセットを配信しています。
          </li>
        </ul>
        <p>
          和文の組版メトリクス (JFM) は upTeX 由来 (修正 BSD ライセンス系)
          で、実フォントとの対応付けは TeX Live 既定 (kanjix.map) と同じく原ノ味を用いています。
        </p>
      </section>
    </>
  );
}
